module.exports = __webpack_public_path__ + "img/ISO-13485-2016.745c35ba.webp";